<template>
  <div class="cart_item payment">
    
    <form id="payment-method" class="needs-validation" novalidate>
      <p class="cardError">{{recurlyCardError}}</p>
      <div class="row">
        <label for="card_number" class>Card Number</label>
        <input
          type="hidden"
          data-recurly="first_name"
          name="billing_first_name"
          :value="user.firstName"
        />
        <input
          type="hidden"
          name="billing_last_name"
          data-recurly="last_name"
          :value="user.lastName"
        />
        <input
          id="card_number"
          name="card_number"
          placeholder="Card Number"
          required
          class="form-control"
          data-recurly="number"
        />
      </div>
      <label>Exp Date</label>
      <div class="row exp_date">
        <div class="col-6">
          <input
            name="month"
            placeholder="MM"
            data-recurly="month"
            maxlength="2"
            required
            class="form-control"
          />
        </div>
        <div class="col-6">
          <input
            name="year"
            data-recurly="year"
            maxlength="2"
            placeholder="YY"
            required
            class="form-control"
          />
        </div>
        <input type="hidden" data-recurly="token" name="recurly_code" />
      </div>
      <div class="row">
        <label for="cvv" class>CVV</label>
        <input
          id="cvv"
          data-recurly="cvv"
          name="cvv"
          placeholder="CVV"
          required
          class="form-control"
        />
      </div>
      <div class="row">
        <label for="postal_code" class>Postal Code</label>
        <input
          id="postal_code"
          name="postal_code"
          placeholder="Postal Code"
          required
          class="form-control"
        />
      </div>
    </form>
  </div>
</template>
<script>
export default {
  props: ['recurlyCardError', 'user']
}
</script>
